












import { Component, Vue, Prop } from "vue-property-decorator";

@Component
export default class VMiniLogo extends Vue {
  @Prop({ default: "" }) readonly path!: string;

  get showSignPost() {
    return this.path !== "";
  }

  clicked() {
    this.$emit("clicked");
  }
}
